module.exports = __webpack_public_path__ + "img/认证标识.9ba00c6f.png";